import React from 'react';
interface TestimonialCardProps {
  name: string;
  role: string;
  quote: string;
}
export function TestimonialCard({
  name,
  role,
  quote
}: TestimonialCardProps) {
  return <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100 flex flex-col" data-id="element-25">
      <p className="text-gray-700 italic text-sm mb-2" data-id="element-26">"{quote}"</p>
      <div className="mt-auto border-t pt-2 border-gray-100" data-id="element-27">
        <p className="font-bold text-gray-900 text-xs" data-id="element-28">{name}</p>
        <p className="text-[10px] text-gray-500" data-id="element-29">{role}</p>
      </div>
    </div>;
}